<template>
  <button :class="['hz-default-tooltip', theme, size]" data-toggle="tooltip" :data-placement="position" :data-html="html" :title="title">
    <i :class="['glyphicon', icon]"></i>
  </button>
</template>
<script>
  export default {
    name: 'tooltip',
    props: {
      theme: {
        type: String,
        default () {
          return ''
        }
      },
      size: {
        type: String,
        default () {
          return 'hz-xs-tooltip'
        }
      },
      title: {
        type: String,
        default () {
          return ''
        }
      },
      position: {
        type: String,
        default () {
          return 'bottom'
        }
      },
      html: {
        type: Boolean,
        default () {
          return false
        }
      },
      icon: {
        type: String,
        default () {
          return 'glyphicon-info-sign'
        }
      }
    },
    mounted () {
      $(this.$el).tooltip({
        animated: 'fade',
        trigger: 'click'
      })

      $(this.$el).on('show.bs.tooltip', () => {
        $('.tooltip').not(this).remove()
      })
    }
  }
</script>

<style lang="scss">
  .hz-default-tooltip {
    padding: 0;
    border: none;
    background: none;
    outline: none;
    color: #adb5bd;
    &:focus {
      outline: none;
    }


    &+ .tooltip {
      z-index: 2;
    }

    &+ .tooltip > .tooltip-inner {
      .tooltip-table {
        th {
          width: 75px;
          padding: 0 !important;
          color: $hzc-white !important;
          border: none !important;
          text-align: center !important;
        }
        td {
          font-size: 12px !important;
          text-align: center !important;
        }
      }
    }
  }

  .hz-warning-tooltip {
    color: $primary-color;
  }

  .hz-error-tooltip {
    color: #FF5747;
  }

  .hz-xs-tooltip + .tooltip > .tooltip-inner {
    min-width: 120px;
    max-width: 160px;
  }
  .hz-md-tooltip + .tooltip > .tooltip-inner {
    min-width: 120px;
    max-width: 350px;
  }
  .hz-lg-tooltip + .tooltip > .tooltip-inner {
    min-width: 120px;
    max-width: 900px;
  }
</style>



// WEBPACK FOOTER //
// ../common/components/Tooltip.vue